/**
 * バリデーション関連の定数
 */

/**
 * 全角カタカナのパターン
 * ァ-ヶ: カタカナ文字
 * ー: 長音記号
 * 　: 全角スペース
 */
export const KATAKANA_PATTERN = /^[ァ-ヶー　]+$/u;

/**
 * カタカナバリデーション用のエラーメッセージ
 */
export const KATAKANA_ERROR_MESSAGE = '全角カタカナで入力してください';